/* eslint-disable react/prop-types */ // I did about 100 prop types for other files. someone else do this one.
import React, { Component } from "react";
import Avatar from "@material-ui/core/Avatar";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import { Link, withRouter } from "react-router-dom";
import { generateChallenge as generateChallengePromise } from "../api";
import SupportDetails from "@app/common/components/SupportDetails";
import FullScreenLoading from "@app/common/components/FullScreenLoad";
import { trackEvent } from "@amplio-common/analytics";
import CommonButton from "@app/common/components/material_ui/Button";
import { TextField } from "juno-shared-components";
import { ReactComponent as Lock } from "@app/assets/svgs/Lock.svg";
import NotAuthenticatedUser from "./usersType/not-authenticated";
import AuthenticatedNotVerifiedUser from "./usersType/authenticated-not-verified";
import { formatStudentCode } from "@amplio-common/funcs/commonFunctionalities";

import { Trans } from "@lingui/macro";

import { css } from "@emotion/react";
import StreamlineIconWrapper from "@app/common/components/StreamlineIconWrapper";

const rootStyle = theme => css`
  .MuiPaper-rounded {
      border-radius: 16px;
  }
  .MuiAvatar-root{
    > span > svg > path{
      stroke: ${theme.colors.lightText};
    }
  }
  .MuiFormControl-marginNormal {
    margin-bottom: 24px;
    margin-top: 18px;
  }
  .body1-text-wrapper{
    text-align: left !important;
  }
  .body1-text-wrapper,
  .body1-code-text-wrapper{
    padding-left: 24px;
  }
  .text-field-wrapper{
    .MuiFormControl-marginNormal {
      margin-bottom: 16px;
    }
  }
  hr {
    flex: 1 1 ;
    height: 1px;
  }
  a{
    text-align: center;
  }
  .or-label {
    flex: 0 0 auto;
    padding: 0 5px;
  }
  .horizontal-container {
    display: flex;
    align-items: center;
    padding: 34px 5px 20px;
    .or-label{
      padding: 0 10px;
      color: ${theme.colors.text.main};
    }
  }
  .forgot-pwd-btn {
    color: ${theme.amplioColor};
    padding: 0;
    font-style: italic;
    margin-top: 16px;

    &:hover {
      text-decoration: underline;
      background-color: initial;
    }
  }

  .MuiInputAdornment-root {
    cursor: pointer;
    color: #666;
  }

  .secondary-action-btn:not(:disabled) {
    background-color: #27426D;
  }
  .buttonWrapper{
    padding-bottom: 16px;
    .MuiCircularProgress-colorPrimary {
      color: ${theme.colors.primary.dark};
    }
  }
  .providers-wrapper{
    display: flex;
    justify-content: center;
    > div{
      padding-right: 40px;
      padding-left: 40px;
      padding-top: 20px;
    }
  }
  .provider-link-wrapper{
    display: flex;
    justify-content: center;
    > div{
      padding-right: 8px;
    }
  }
  .body1{
    color: ${theme.colors.text.main};
    span {
      font-family: ${theme.typography.fontFamily};
    }
  }
`;

const styles = iTheme => ({
  main: {
    fontFamily: "Lexend",
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: iTheme.spacing(3),
    marginRight: iTheme.spacing(3),
    [iTheme.breakpoints.up(400 + iTheme.spacing(3) * 2)]: {
      // width: 420,
      width: 488,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: iTheme.spacing(2),
    display: "flex",
    // paddingBottom: 0,
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 16,
    padding: `${iTheme.spacing(2)}px ${iTheme.spacing(3)}px ${iTheme.spacing(0)}px ${iTheme.spacing(3)}px`,
  },
  avatar: {
    margin: iTheme.spacing(),
    backgroundColor: "#F1F6FD",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: iTheme.spacing(5.5),
    display: "flex",
    flexDirection: "column",
  },
  submit: {
    marginTop: iTheme.spacing(2),
  },
  button: {
    marginTop: iTheme.spacing(),
  },
  support: {
    padding: "60px 30px 25px !important",
  },
});

const USERNAME_VALUE = 0;
const PASSWORD_LOGIN = 1;
const TREATMENT_CODE_LOGIN = 2;

class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.password = React.createRef();
    this.otp = React.createRef();
    this._handleSubmit = this._handleSubmit.bind(this);
    this.state = {
      allowResendOTP: false,
      isShowPassword: false,
      presentationMode: USERNAME_VALUE,
      username: "",
      email: "",
      fullname: "",
      code: this.props.match?.params?.code?.trim()?.replaceAll(" ", "-")?.replace(/-+/g, "-") || "",
      class_code: this.props.match?.params?.class_code?.trim()?.replaceAll(" ", "-")?.replace(/-+/g, "-") || "",
      isInitialCodeLoading: this.props.match?.params?.code?.trim()?.replaceAll(" ", "-")?.replace(/-+/g, "-") || false,
      copyErrors: this.props.errors || [],
    };
  }

  componentDidMount() {
    const { code, class_code } = this.props.match.params;
    const { presentationMode } = this.state;
    if (class_code) trackEvent("next_login_step", { entry_type: "class_link_or_QR" });
    if ((code || class_code) && !this.props.currentUser.is_otp_required) {
      this._handleSubmit();
    }
    !localStorage.getItem("access_token") && presentationMode === USERNAME_VALUE && trackEvent("login_page_view");
  }

  componentDidUpdate(prevProps, prevState) {
    this.state.isInitialCodeLoading && prevProps.isLoading && !this.props.isLoading && this.setState({ isInitialCodeLoading: false });
    prevState.presentationMode !== USERNAME_VALUE && this.state.presentationMode === USERNAME_VALUE && trackEvent("login_page_view");

    if (prevProps.errors !== this.props.errors && this.props.errors) {
      this.setState({ copyErrors: [...this.props.errors] });
    }
  }

  _handleSubmit(e) {
    const { login, codeLogin, otpLogin, studentLoginOTP, match, loginValue, currentUser } = this.props;
    const { code, fullname, presentationMode, class_code, email } = this.state;
    const username = this.state.username.trim();
    e && e.preventDefault();
    e && e.stopPropagation();

    localStorage.setItem("loginRequest", true);
    if ((match.path.includes("/code") || code === username) && code.trim() !== "") {
      let trimedCode;
      if (currentUser.is_otp_required && this.otp.current) {
        studentLoginOTP(this.otp.current.value.trim());
        return;
      }

      if (/\s/g.test(code)) trimedCode = code.replace(/\s/g, "");
      const formattedCode = formatStudentCode(trimedCode || code);
      codeLogin(formattedCode || "blank", email); // using blank to get server to return wrong code msg
    }

    if (match.path.includes("/class_code") && presentationMode === USERNAME_VALUE && username.trim() === "") {
      this.setState({ presentationMode: TREATMENT_CODE_LOGIN });
      return;
    }

    if (!localStorage.getItem("access_token") && presentationMode === USERNAME_VALUE) {
      this.checkInputFormat();
      return;
    }

    if (fullname.trim() !== "" && presentationMode === TREATMENT_CODE_LOGIN) {
      loginValue(username?.toUpperCase().split("-").join("") || class_code.split("-").join(""), fullname);
      return;
    }

    if (!this.props.currentUser.isAuthenticated) {
      this.setState({ username });
      login(username, this.password.current?.value?.trim());
    } else {
      otpLogin(this.otp.current.value.trim());
    }
  }

  onResendOTPClick = () => {
    this.setState({ allowResendOTP: false }, generateChallengePromise);
  }

  changeUsername = (e) => {
    this.setState({ username: e.target.value });
  }

  handleSocialLink = (provider) => {
    trackEvent("SSO_login_click", { SSO_type: provider });
    this.props.socialLogin(provider);
  }

  changeFullname = (e) => {
    this.setState({ fullname: e.target.value });
  }

  _isEmailValid = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email)) return true; //eslint-disable-line
    return true;
  }

  handleLoginCode = (lCode) => {
    trackEvent("next_login_step", { entry_type: "student_code" });
    this.setState({ code: lCode }, () => this._handleSubmit());
  }

  backButtonClick = () => {
    const { history } = this.props;

    if (this.props.match.path.includes("/code") && !this.props.currentUser.isAuthenticated) {
      history.push("/home/");
    }
    this.setState({ presentationMode: USERNAME_VALUE });
    this.setState({ copyErrors: [] });
  }

  checkCodeType = () => {
    const { username } = this.state;
    let joinUsername = username;
    if (/\s/g.test(joinUsername)) {
      joinUsername = joinUsername.replace(/\s/g, "");
    }
    const loginCodeParams = joinUsername.trim().split("-");
    const loginCode = loginCodeParams.join("");
    let isLoginValueOption = false;
    let isStudentCodeOption = false;

    if (loginCode.length === 9) {
      const firstStr = loginCode.slice(0, 3);
      const secondStr = loginCode.slice(3, 6);
      const thirdStr = loginCode.slice(6, 9);
      const hasOnlyNumber = /^\d+$/;
      const hasOnlyLetters = /^[a-z]+$/i;

      isLoginValueOption = hasOnlyLetters.test(firstStr) && hasOnlyNumber.test(secondStr) && hasOnlyNumber.test(thirdStr);
    }

    if (loginCode.length === 8) {
      const secondStr = loginCode.slice(2, 5);
      const thirdStr = loginCode.slice(5, 8);
      const hasOnlyNumber = /^\d+$/;

      isStudentCodeOption = hasOnlyNumber.test(secondStr) && hasOnlyNumber.test(thirdStr);
    }

    return {
      isLoginValueOption,
      isStudentCodeOption,
    };
  }

  checkInputFormat = () => {
    const { username } = this.state;

    if (username.trim() === "") {
      trackEvent("login_error_shown", { error_type: "empty_field" });
    } else {
      const { isLoginValueOption, isStudentCodeOption } = this.checkCodeType();

      if (isLoginValueOption) {
        this.setState({
          presentationMode: TREATMENT_CODE_LOGIN,
        }, () => trackEvent("next_login_step", { entry_type: "class_code" }));
        return;
      }

      if (isStudentCodeOption) {
        this.handleLoginCode(this.state.username);
        return;
      }
      trackEvent("next_login_step", { entry_type: "random_string" });
      this.setState({ presentationMode: PASSWORD_LOGIN });
    }
  }

  updateState = (prop, value) => {
    this.setState({ [prop]: value });
  }

  StudentInputFields = () => {
    const { currentUser, isLoading } = this.props;
    const { email, code } = this.state;
    return (
      <>
        {currentUser.isEmailRequired ? (
          <Trans render={({ translation }) => (
            <TextField
              placeholder={translation}
              autoFocus
              value={email}
              disabled={isLoading}
              onChange={(e) => this.setState({ email: e.target.value.trim().replaceAll(" ", "-").replace(/-+/g, "-") })}
            />
          )}
          >Email
          </Trans>
        ) : (
          <TextField
            label={<Trans>Code</Trans>}
            autoFocus
            value={code}
            disabled={isLoading}
            onChange={(e) => this.setState({ code: e.target.value.trim().replaceAll(" ", "-").replace(/-+/g, "-") })}
          />
        )}
      </>
    );
  }

  render() {
    const { classes, currentUser, errors, match } = this.props;
    const { allowResendOTP, isShowPassword, isInitialCodeLoading, presentationMode, copyErrors } = this.state;

    const isusernameLoginCode = this.state.username.split("-").length === 3;
    let ErrorMessage = null;
    if (copyErrors && !this.props.isLoading) {
      ErrorMessage = copyErrors.map((errorMessage, index) => (
        <div key={`err-${index + 1}`} style={{ color: "red", paddingBottom: "16px" }}>
          {errorMessage === "No active account found with the given credentials" && (
            <Trans>Unable to log in with provided credentials: username or password is incorrect.</Trans>
          )}
          {errorMessage === "Please make sure you are using the correct class code and correct student name." && (
            <Trans>Please make sure you are using the correct class code and correct student name.</Trans>
          )}
        </div>
      ));
    }

    if (isInitialCodeLoading) return <FullScreenLoading />;
    if (match.path.includes("/code") && !currentUser.isAuthenticated && currentUser.isEmailRequired) {
      return (
        <div className={classes.main} css={rootStyle}>
          <CssBaseline />

          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <StreamlineIconWrapper><Lock /></StreamlineIconWrapper>
            </Avatar>
            <div className="h6" style={{ color: "#0F1140" }}>
              <Trans>Login</Trans>
            </div>
            <form className={classes.form} onSubmit={this._handleSubmit}>
              <div className="body1" style={{ textAlign: "center" }}>
                {currentUser.isEmailRequired
                  ? <Trans>Log in with Email below.</Trans>
                  : <Trans>Log in with personal code below.</Trans>}

              </div>
              <FormControl margin="normal" required fullWidth>
                {this.StudentInputFields()}
              </FormControl>
              <span style={{ color: "red", marginBottom: "1rem" }}><Trans id={currentUser.message} values={currentUser.message} /></span>
              {ErrorMessage}
              <div className="buttonWrapper">
                <CommonButton
                  type="submit"
                  fullWidth
                  size="large"
                  variant="contained"
                  color="primary"
                  className="classes.submit"
                  disabled={this.state.code.trim() === "" || !this._isEmailValid()}
                  isLoading={this.props.isLoading}
                >
                  <Trans>Submit</Trans>
                </CommonButton>
              </div>
              <div className="buttonWrapper">
                {!currentUser.isEmailRequired && (
                <CommonButton
                  fullWidth
                  size="large"
                  variant="contained"
                  color="secondary"
                  className="not-authenticated-submit"
                  onClick={() => this.backButtonClick()}
                >
                  <Trans>Back</Trans>
                </CommonButton>
                )}
              </div>
              <Link to="/login" onClick={() => { this.setState({ copyErrors: [] }); }}>
                <Trans>login with username and password</Trans>
              </Link>
              <SupportDetails showEmail={false} />
            </form>
          </Paper>
        </div>
      );
    }

    return (
      <>
        <main className={classes.main} css={rootStyle}>
          <CssBaseline />
          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <StreamlineIconWrapper><Lock /></StreamlineIconWrapper>
            </Avatar>
            <div className="h6" style={{ color: "#0F1140" }}>
              {presentationMode === USERNAME_VALUE
                && !currentUser.username
                ? (<Trans>Login</Trans>)
                : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {isusernameLoginCode
                      && (
                        <div style={{ fontWeight: "normal", fontSize: "16px" }}>
                          <Trans>Login with personal code</Trans>
                        </div>
                      )}
                    {this.state.username || currentUser.username}
                  </div>
                )}
            </div>
            <form className={classes.form} onSubmit={this._handleSubmit}>
              {!currentUser.isAuthenticated && (
                <NotAuthenticatedUser
                  presentationMode={presentationMode}
                  username={this.state.username}
                  isShowPassword={isShowPassword}
                  changeUsername={this.changeUsername}
                  errors={errors}
                  password={this.password}
                  checkInputFormat={this.checkInputFormat}
                  isLoading={this.props.isLoading}
                  fullname={this.state.fullname}
                  changeFullname={this.changeFullname}
                  backButtonClick={this.backButtonClick}
                  handleSocialLink={this.handleSocialLink}
                  updateState={this.updateState}
                  ErrorMessage={ErrorMessage}
                />
              )}
              {currentUser.isAuthenticated && !currentUser.isVerified && (
                <AuthenticatedNotVerifiedUser
                  onResendOTPClick={this.onResendOTPClick}
                  isLoading={this.props.isLoading}
                  allowResendOTP={allowResendOTP}
                  otp={this.otp}
                  updateState={this.updateState}
                  ErrorMessage={ErrorMessage}
                />
              )}
              <SupportDetails showEmail={false} className={classes.support} />
            </form>
          </Paper>
        </main>
      </>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(LoginComponent));
